import React from "react"

type Props = {
  children: React.ReactNode
  className?: string
  id?: string
}

const Paragraph = ({ children, className, id }: Props) => {
  return (
    <p
      id={id}
      className={
        `font-raleway-medium text-xs sm:text-sm md:text-base font-light text-justify ` +
        className
      }
    >
      {children}
    </p>
  )
}

export default Paragraph
